export const creditCardSvg = (
  <svg
    data-testid="ock-creditCardSvg"
    role="img"
    aria-label="ock-creditCardSvg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Credit Card</title>
    <path
      d="M0.478516 2.33325V12.9999H13.5228V2.33325H0.478516ZM12.164 3.99992V5.33325H1.83729V3.99992H12.164ZM1.83729 11.3333V7.66659H12.164V11.3333H1.83729Z"
      className="fill-ock-foreground"
    />
    <path
      d="M2.65256 8.66659H7.00064V9.66659H2.65256V8.66659Z"
      className="fill-ock-foreground"
    />
  </svg>
);
